import { getOrCreateRevenueCatCustomer } from "@helpers/getOrCreateRevenueCatCustomer"
import { getUser } from "@helpers/supabase"
import { RevenueCatCustomer, RevenueCatSubscription } from "../types"

export interface GetSubscriptionLoaderData {
  revenueCatSubscriptions: RevenueCatSubscription[];
  userEmail: string | undefined;
}

export default async function getSubscriptionLoader(): Promise<GetSubscriptionLoaderData> {
  const { userId, userEmail } = await getSupabaseUser()

  if (!userId)
    return { revenueCatSubscriptions: [], userEmail: undefined }

  const revenueCatCustomer: RevenueCatCustomer =
    await getOrCreateRevenueCatCustomer(userId)

  const revenueCatSubscriptions = Object.entries(
    revenueCatCustomer?.subscriber.subscriptions ?? {},
  ).map(([productId, subscription]) => ({
    ...subscription,
    productId,
  }))

  return {
    revenueCatSubscriptions: Object.values(revenueCatSubscriptions),
    userEmail,
  }
}

async function getSupabaseUser(): Promise<{
  userEmail: string | undefined;
  userId: string | undefined;
}> {
  const { data } = await getUser()

  return {
    userEmail: data?.user?.email,
    userId: data?.user?.id,
  }
}
